<template>
  <div class="top-menu">
    <div class="stories-container" :class="{'show': isMobile && screenWidth}">
      <div v-if="!isTripsider">
        <Stories />
      </div>
    </div>

    <div class="tour-date-selector-container" :class="{'loaded': isMobile && screenWidth}" >
      <div v-if="isMobile && screenWidth">
        <TourDateSelector
          @showSelectorPopup="showSelectorPopup"
          @clearSearch="clearTourDateSearch"
        />
      </div>
    </div>

    <div v-if="!isMobile && screenWidth"  class="top-menu__search-container">
      <div class="top-menu__tabs" v-if="isShowTabs">
        <div class="top-menu__tabs-container">
          <YtTab
            :tabs="tabs"
            :selectedIndex="getActiveTab"
            @select="setActiveTab"
          />
        </div>
      </div>

      <div class="top-menu__search" v-if="nonSSR" >
        <TourSearch
          class="search"
          ref="search"
          @updateLocation="
          selectLocation($event && [$event]);
          $refs.searchFixed.setLocation($event);
        "
          @searchChange="$refs.searchFixed.setLocationSearch($event)"
          @updateDate="
          selectDates($event && [$event]);
          $refs.searchFixed.setDate($event);
        "
          @switchPeriod="setStrictPeriod($event)"
        />
      </div>
      <div v-else class="top-menu__fake">
        <div class="top-menu__fake-search"></div>
      </div>
    </div>


    <popup-slide
      v-if="isMobile && screenWidth"
      :title="$t('serp.topMenu.searchMob')"
      :show="isSelectorPopupShow"
      :block-page-scroll="!mobileDatePopupIsOpen"
      @close="closeSelectorPopup">
      <slot>
        <div class="top-menu__tabs-mob" v-if="isShowTabs">
          <YtTab
            :tabs="tabs"
            :selectedIndex="getActiveTab"
            @select="setActiveTab"
          />
        </div>
        <div class="top-menu__search-mob" v-if="nonSSR && isSelectorPopupShow">
          <div  class="top-menu__fake-mob">
            <div class="top-menu__fake-mob-loc"> </div>
            <div class="top-menu__fake-mob-date"> </div>
          </div>
          <TourSearch
            class="search"
            ref="searchMobile"
            :showDivider="false"
            @updateLocation="selectedLocation = $event && [$event];"
            @updateDate="selectedDates = $event && [$event];"
            @switchPeriod="setStrictPeriod($event)"
          />
        </div>
        <div v-else class="top-menu__fake-mob">
          <div class="top-menu__fake-mob-loc"> </div>
          <div class="top-menu__fake-mob-date"> </div>
        </div>

        <yt-button
          class="top-menu__search-mb-btn"
          squared="true"
          @click="setDateLocationFilters"
        > {{ $t("serp.topMenu.search") }} </yt-button>
      </slot>
    </popup-slide>

    <div class="top-menu__filters u-fixed-center-x">
      <yt-button @click="$emit('showFilter')">
        <span class="u-flex u-flex-items-center">
          <span class="top-menu__filters-icon u-flex-shrink-0">
            <svg-inline tag="span">
              <transition name="fade" mode="out-in">
                <icon
                  :key="showReset"
                  :icon="`setting${showReset ? '-active' : ''}`"
                />
              </transition>
            </svg-inline>
          </span>
          <span v-html="$t('serp.filters.trigger')"></span>
        </span>
      </yt-button>
    </div>

    <div
      class="top-menu__suggest"
      :class="{ 'top-menu__suggest--hidden': !isShowPresets }"
      id="suggest"
    >
      <div class="top-menu__suggest-container">
        <div
          v-if="isRussian"
          class="top-menu__suggest__item"
          @click="openBanner"
        >
          <Icon icon="app-top-menu" class="img" />

          <div class="font-text">Скачать приложение</div>
        </div>

        <template v-for="preset in presets">
          <div
            class="top-menu__suggest__item"
            :key="preset.ID"
            @click="clickPreset(preset)"
          >
            <img :src="preset.PICTURE" :alt="preset.NAME" class="img" loading="lazy" />

            <div class="font-text" v-text="preset.NAME"></div>
          </div>
        </template>
      </div>
    </div>

    <transition name="slide">
      <div class="top-menu__search-fixed" v-show="isStickySearch" v-if="nonSSR">
        <TourSearch
          v-if="!isMobile && screenWidth"
          class="search"
          ref="searchFixed"
          @updateLocation="
            selectLocation($event && [$event]);
            $refs.search.setLocation($event);
          "
          @searchChange="$refs.search.setLocationSearch($event)"
          @updateDate="
            selectDates($event && [$event]);
            $refs.search.setDate($event);
          "
          @switchPeriod="setStrictPeriod($event)"
        />
        <TourDateSelector
          v-if="isMobile && screenWidth"
          @showSelectorPopup="showSelectorPopup"
          @clearSearch="clearTourDateSearch"
        />
      </div>
    </transition>

    <BannerAppModal :qr-code-url="bannerQrCodeUrl" ref="bannerAppModal" />
  </div>
</template>

<script>
import BannerAppModal from "@/components/templates/banner-app-modal/index.vue";
import YtButton from "@/components/ui-kit/yt-button/index.vue";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";
import { mapState, mapMutations } from "vuex";
import { axiosTour } from "@/services/scopes/axios-tour.js";
import { useBannerApp } from "@/state/banner-app";
import { ytEvents } from "@/plugins/analytics";
import { i18n } from "@/plugins/i18n";
import { ref } from "vue";
import PopupSlide from '@/components/ui-kit/yt-popup-slide';
import TourDateSelector from "./tour-date-selector";
import YtTab from "@/components/ui-kit/yt-tab";
import Stories from "./stories.vue";
import { ytVueGlobalStore } from "@/services/yt-vue-global-store";

export default {
  name: "top-menu",
  components: {
    BannerAppModal,
    TourDateSelector,
    Stories,
    TourSearch: () => import("@/components/ui-kit/tour-search/index.vue"),
    YtButton,
    SvgInline,
    Icon,
    YtTab,
    PopupSlide,
  },
  data() {
    return {
      isRussian: i18n.locale === "ru",
      isStickySearch: false,
      slideShow: false,
      presets: {},
      seoText:
        "Найдите подходящий для вас тур по Армении. У нас 39 приключений в Армению, начиная всего с трех дней, и самый длинный тур – 14 дней. Наиболее популярным месяцем является май, который имеет наибольшее количество туров.",
      tabs: [
        { "label": this.$t("serp.topMenu.manyDays") },
        { "label": this.$t("serp.topMenu.oneDay") },
        { "label": this.$t("serp.topMenu.unusual") },
      ],
      tabsIds:["multiDays", "oneDay", "exclusive"],
      selectedDates: "",
      selectedLocation: "",
      screenWidth: 0,
      nonSSR: false,
    };
  },
  computed: {
    ...mapState({
      query: (state) => state.serp.serpQuery.query,
      ssrPresets: (state) => state.serp.serpTours?.presets?.data,
      showReset: (state) => state.serp.showReset,
      dates: (state) => state.serp.dates,
      location: (state) => state.serp.location,
      only_exclusive: (state) => state.serp.only_exclusive,
      productType: (state) => state.serp.productType,
      mobileDatePopupIsOpen: (state) => state.serp.mobileDatePopupIsOpen,
    }),
    getActiveTab(){
      return  this.tabsIds.findIndex((item) => item === this.productType);
    },
    isMultiDaysProduct() {
      return this.productType === 'multiDays';
    },
    isOneDayProduct() {
      return this.productType === 'oneDay';
    },
    isExclusiveProduct() {
      return this.productType === 'exclusive';
    },
    isShowPresets() {
      return this.presets && Object.values(this.presets).length;
    },
    isShowTabs() {
      return this.isRussian;
    },
    isMobile() {
      return this.screenWidth < 943 ;
    },
    isSelectorPopupShow(){
      return this.slideShow
    },
    isTripsider() {
      const languageStore = ytVueGlobalStore.instantGet('language');
      return languageStore?.id === 'en';
    },
  },
  watch: {
    dates(val) {
      if(!this.isMobile) {
        this.$refs.search?.setDate(val);
        this.$refs.searchFixed?.setDate(val);
      }
    },
    location(val) {
      if(!this.isMobile) {
        this.$refs.search?.setLocation(val);
        this.$refs.searchFixed?.setLocation(val);
      }
    },
  },
  setup() {
    const { getQrCodeUrl } = useBannerApp();

    const bannerAppModal = ref(undefined);
    const bannerQrCodeUrl = ref(undefined);

    async function openBanner() {
      ytEvents.track("Tour list", "Click Download banner");
	  ytEvents.track("Tour list", "Click Suggestion", "Скачать приложение");
      bannerQrCodeUrl.value = await getQrCodeUrl();
      bannerAppModal.value.open();
    }

    return {
      openBanner,
      bannerQrCodeUrl,
      bannerAppModal,
    };
  },
  async created() {
    this.updateWidth();
    if (this.ssrPresets && Object.values(this.ssrPresets).length) {
      this.presets = this.ssrPresets;
    }

    if (!vueOptions.ssr) {
      const presets = await axiosTour.getPresets().catch((e) => console.log(e));
      if (presets?.data?.success) {
        this.presets = presets.data.data;
      }
      this.nonSSR = true;
    }
  },
  mounted() {
    fakeWindow.addEventListener("scroll", this.initSuggest);
    fakeWindow.addEventListener("resize", this.setSearchBtnText);
    fakeWindow.addEventListener('resize', this.updateWidth);
    this.setSearchBtnText();
    this.setStrictPeriod(true);
  },
  beforeDestroy() {
    fakeWindow.removeEventListener("scroll", this.initSuggest);
    fakeWindow.removeEventListener("resize", this.setSearchBtnText);
    fakeWindow.removeEventListener('resize', this.updateWidth);
  },
  methods: {
    ...mapMutations({
      selectDates: "serp/selectDates",
      selectLocation: "serp/selectLocation",
      setStrictPeriod: "serp/setStrictPeriod",
      setIsOnlyExclusive: "serp/setIsOnlyExclusive",
      setProductType: "serp/setProductType",
    }),
    updateWidth() {
      this.screenWidth = fakeWindow.innerWidth;
    },
    setDateLocationFilters() {
      this.selectDates(this.selectedDates == '' ? this.dates : this.selectedDates );
      this.selectLocation(this.selectedLocation == ''  ? this.location : this.selectedLocation);
      this.scrollTop();
      this.slideShow = false;
    },
    setActiveTab(event) {
      let type = this.tabsIds[event];
      this.setProductType(type);
      this.setIsOnlyExclusive(type === "exclusive");
    },
    showSelectorPopup(){
      this.slideShow = true;
    },
    closeSelectorPopup(){
      this.slideShow = false;
    },
    clickPreset(preset) {
	  ytEvents.track("Tour list", "Click Suggestion", preset.NAME);
      fakeWindow.open(preset.PROPERTY_BANNER_LINK_VALUE, "_blank").focus();
    },
    setSearchBtnText() {
      if (fakeWindow.innerWidth >= 768 && fakeWindow.innerWidth <= 1279) {
        this.searchBtnText = this.$t("serp.topMenu.search");
      } else {
        this.searchBtnText = this.$t("serp.topMenu.searchLong");
      }
    },
    scrollTop() {
      fakeWindow.scrollTo(0, 0);
    },
    initSuggest() {
      const elementTarget = document.getElementById("suggest");

      if (document.body.style.position !=='fixed') {
        this.isStickySearch =
          (window.scrollY > elementTarget.offsetTop + elementTarget.offsetHeight + 40) ;
      }
    },
    downloadAppClick() {
      ytEvents.track("Tour list", "Click Download banner");
      ytEvents.track("Tour list", "Click Suggestion", "Скачать приложение");
      this.$refs.bannerAppModal.open();
    },
    clearTourDateSearch(){
      this.selectDates(null);
      this.selectLocation(null);
      this.selectedLocation = '';
      this.selectedDates = '';
      this.scrollTop();
    },
  },
};
</script>

<style lang="scss" scoped>
.top-menu {
  width: 100%;
  padding: 0px 16px;

  &__fake {
    display:none;
    @media (min-width: var.$lg) {
      display: block;
      max-width: 1176px;
      margin: auto;
    }
    &-search{
      display: none;
      &::before{
        content: "";
        display: block;
        width: 1px;
        height: 32px;
        margin: 16px auto;
        background: var.$gray-dark;
      }
      @media (min-width: var.$lg) {
        display: flex;
        height: 64px;
        width: 600px;
        border-radius: 12px;
        background: var.$gray-light;
      }
    }

    &-mob{
      position: absolute;
      width: 100%;
      height: 130px;
      top: 0;
      &-loc{
        width: 100%;
        border-radius: 12px 12px 0 0;
        position: relative;
        display: flex;
        align-items: center;
        height: 64px;
        background: #eeeef2;
        border: 1px solid transparent;
        margin: 0 0 2px 0;
      }
      &-date{
        width: 100%;
        border-radius: 0 0 12px 12px;
        position: relative;
        display: flex;
        align-items: center;
        height: 64px;
        background: #eeeef2;
        border: 1px solid transparent;
      }
    }
  }

  &__search-container{
    min-height: 115px;
    display: none;
  }

  &__search-fixed {
    top: 0;
    left: 0;
    width: 100%;
    position: fixed;
    background: #fff;
    padding: 8px 16px;
    z-index: 999;
    box-shadow: -2px 1px 28px rgba(153, 153, 169, 0.3);

    .search {
      width: 100%;
      max-width: 1176px;
      margin: auto;
    }
  }

  &__seo {
    color: var.$secondary;
    max-width: 1176px;
    margin: 0 auto 32px auto;
  }

  &__header {
    display: flex;
    align-items: center;
    grid-gap: 14px;
    margin: 0 auto 24px auto;
    max-width: 1176px;

    & > span {
      font-family: "SF Pro Display";
      font-style: normal;
      font-weight: 700;
      font-size: 24px;

      &:nth-child(1) {
        color: var.$black;
      }
      &:nth-child(2) {
        color: var.$gray-dark;
      }
    }
  }

  &__search {
    max-width: 1176px;
    margin: auto;
    position: relative;
    height: 64px;

    &::before{
      content: "";
      display:none;

      @media (min-width: var.$lg) {
        display:block;
        height: 64px;
        width: 600px;
        border-radius: 12px;
        background: var.$gray-light;
        position: absolute;
      }
    }
    &::after{
      content: "";
      display:none;

      @media (min-width: var.$lg) {
        display: block;
        width: 1px;
        height: 32px;
        margin: 16px auto;
        left: 300px;
        top: 0;
        background: var.$gray-dark;
        position: absolute;
      }
    }
    .search {
      max-width: 400px;
    }

    @media (min-width: var.$lg) {
      .search {
        max-width: 600px;
      }
    }
  }

  &__filters {
    bottom: 16px;
    z-index: 1;

    &-icon {
      width: 24px;
      margin-right: 4px;
    }
  }

  &__suggest {
    position: relative;
    margin: 0 -16px;

    @include mixins.serp-photo-bg {
      background: var.$gray-light;

      &::after {
        content: '';
        display: block;
        position: absolute;
        right: 16px;
        bottom: 0;
        left: 16px;
        height: 1px;
        background: var.$gray-dark;
      }
    }

    &--hidden {
      display: none;
    }

    &-container {
      display: grid;
      grid-auto-flow: column;
      grid-gap: 10px;
      padding: 20px 16px;
      max-width: var.$size-xl;
      margin: 0 auto;
      overflow: visible;
      overflow-x: auto;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    &__item {
      display: flex;
      align-items: center;
      width: 192px;
      min-width: 192px;
      background: var.$white;
      box-shadow: 1px 2px 45px rgba(153, 153, 169, 0.22);
      border-radius: 12px;
      padding: 4px 12px 4px 8px;
      cursor: pointer;
      transition: all 200ms;
      color: var.$black;

      &:hover {
        box-shadow: 1px 2px 45px rgba(153, 153, 169, 0.22);
        transform: translateY(-4px);

        div {
          color: var.$green-main;
        }
      }

      & > .img {
        min-width: 24px;
        width: 24px;
        height: 24px;
        object-fit: cover;
        border-radius: 4px;
        flex-shrink: 0;
        margin-right: 10px;
      }

      & .font-text {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
  &__tabs-mob{
    width: 100%;
    margin-bottom: 12px
  }
  &__tabs {
    max-width: 400px;
    display: none;

    @media (min-width: var.$lg) {
      display: block;
      max-width: 1176px;
      margin: auto;
    }

    &-container {
      margin-bottom: 4px;
      width: 350px;
    }
  }
}

@media (min-width: var.$size-md) {
  .top-menu {
    padding: 40px 40px 0;

    &__search-container {
      display: block;
      margin-bottom: 24px;
    }

    &__search {
      flex-direction: row;

      &__inputs {
        flex-direction: row;
        margin-right: 12px;
        margin-bottom: 0;

        > * + * {
          margin-top: 0;
        }

        &__divider {
          display: block;
        }

        &__destination {
          & >>> {
            .serp-tour-selector {
              border-radius: 12px 0 0 12px;
            }
          }
        }

        &__date {
          border-radius: 0 12px 12px 0;
        }

        &__fixed__wrapper {
          padding: 12px 40px;
        }
      }

      &__button {
        min-width: 120px;
        max-width: 120px;

        &__fixed {
          display: flex;
          min-width: 120px;
          max-width: 120px;
        }
      }
      &-fixed {
        padding: 24px 40px;
      }
    }

    &__suggest {
      margin: 0 -40px;

      @include mixins.serp-photo-bg {
        &::after {
          content: none;
        }
      }

      &-container {
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 16px;
        padding: 16px 40px 40px;
        overflow-x: visible;
      }

      &__item {
        width: 100%;
        padding: 13px;

        & .img {
          min-width: 56px;
          width: 56px;
          height: 56px;
          margin-right: 16px;
        }
        & .font-text {
          font-size: 13px;
          line-height: 17px;
        }
      }
    }
  }
}

@media (min-width: var.$size-lg) {
  .top-menu {
    &__header {
      & > span {
        font-size: 48px;
      }
    }

    &__filters {
      display: none;
    }

    &__suggest {
      &container {
        grid-template-columns: repeat(5, 1fr);
      }
    }

    &__search__inputs__fixed__wrapper {
      z-index: 89001;
    }
  }
}

@media (min-width: var.$size-xl) {
  .top-menu__search__button,
  .top-menu__search__button__fixed {
    min-width: 292px;
    max-width: 292px;
  }

  .top-menu__seo {
    & > div {
      width: 50%;
    }
  }

  .top-menu {
    &__search {
      &__inputs {
        &__destination {
          & >>> {
            .multiselect__content-wrapper {
              width: 200%;
            }
          }
        }
      }
    }
  }
}

.top-menu__search-mob{
  width: 100%;
  position: relative;
  height: 130px;
}
.top-menu__search-mob .search{
  width: 100%;
  max-width:100%;
}

.top-menu__search-mb-btn{
  width: 100%;
  margin-top: 20px
}
.tour-date-selector-container{
  width: 100%;
  background: var.$gray-light;
  border-radius: 12px;
  min-height: 51px;

  @include mixins.serp-photo-bg {
    margin-bottom: 20px;
  }

  @media (min-width: var.$lg) {
    background: none;
    display: none;
  }

  &.loaded{
    background: none;
  }
}
.slide-enter-active,
.slide-leave-active {
transition: transform 200ms;
}

.slide-enter,
.slide-leave-to {
transform: translateY(-80px);
}

.stories-container {
  display: none;

  &.show {
    display: block;
  }

  @include mixins.serp-photo-bg {
    color: var.$white;
  }
}
</style>
